var F = Object.defineProperty;
var c = (e, s, t) => s in e ? F(e, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[s] = t;
var i = (e, s, t) => c(e, typeof s != "symbol" ? s + "" : s, t);
var h = /* @__PURE__ */ ((e) => (e.FailedFetchSessionsActive = "FailedFetchSessionsActive", e.FailedFetchSessionsRefresh = "FailedFetchSessionsRefresh", e.FailedFetchSessionsLogout = "FailedFetchSessionsLogout", e))(h || {});
class a extends Error {
  constructor(t, o) {
    super(o);
    i(this, "type");
    this.name = t, this.type = t;
  }
}
export {
  a as TMBError,
  h as TMBErrorType
};
